<template>
    <v-modal title="Edit tags" @close="$emit('close')" scroll>
        <div slot="contents">
            <div class="modal-content">
                <p class="stack-m">
                    {{ modalDescriptionMessage }}, if you want to manage your tags
                    <router-link :to="{name: 'tags'}">click here</router-link>
                    .
                </p>
                <v-tag-input
                    v-fs-block
                    @update="updateNewTagsList"
                    :disabled="disabled"
                    :loading="loading"
                    :can-add="canAdd"
                    :value="newTagsList.value"
                    :async-get-init-value="asyncGetInitValue"
                    :async-find="asyncFind"
                    :async-config="asyncConfig"
                    :placeholder="tagInputPlaceholder"/>
            </div>
        </div>
        <template slot="actions">
            <r-button type="primary" @click="save">Apply</r-button>
        </template>
    </v-modal>
</template>

<script>
    import vModal from '@/components/modal/v-modal';
    import {
        vCheckbox, vTagInput,
    } from '@/components/form';
    import {modalDescriptionMessages} from '@/components/tags-manager/tag-messages';

    export default {
        name: 'tags-manager-modal',
        components: {
            vTagInput,
            vCheckbox,
            vModal,
        },
        props: {
            loading: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            canAdd: {
                type: Boolean,
                default: false,
            },
            type: String,
            tagInputPlaceholder: String,
            valuesList: Array,
            updateTags: Function,
            asyncGetInitValue: Function,
            asyncFind: Function,
            asyncConfig: {
                type: Object,
                default: () => ({}),
            },
        },
        data() {
            return {
                newTagsList: {
                    value: this.valuesList,
                    created: [],
                },
            };
        },
        watch: {
            valuesList(value) {
                this.newTagsList.value = value;
                this.newTagsList.created = [];
            },
        },
        computed: {
            modalDescriptionMessage() {
                return modalDescriptionMessages[this.type];
            },
        },
        methods: {
            save() {
                this.$emit('update', this.newTagsList);
            },
            updateNewTagsList({value, created}) {
                this.newTagsList.value = value;
                this.newTagsList.created = created;
            },
        },
    };
</script>
